import { render, staticRenderFns } from "./headerTab.vue?vue&type=template&id=6da9b755&scoped=true&"
import script from "./headerTab.vue?vue&type=script&lang=js&"
export * from "./headerTab.vue?vue&type=script&lang=js&"
import style0 from "./headerTab.vue?vue&type=style&index=0&id=6da9b755&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da9b755",
  null
  
)

export default component.exports